import type { ReactNode } from "react";
import { SiteHeader } from "./SiteHeader";
import "./site-frame.css";

export function SiteFrame({ children }: { children: ReactNode }) {
  return (
    <div className="athlete-site">
      <a className="athlete-skip-link" href="#athlete-page-main">
        跳到主要内容
      </a>
      <SiteHeader />
      <main id="athlete-page-main">{children}</main>
    </div>
  );
}
